import { jsx as _jsx } from "react/jsx-runtime";
import { DatePicker } from '@bos/ui';
import { useController } from 'react-hook-form';
export const DatePickerField = ({ control, name, registerOptions, ...appDatePickerProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: undefined,
        ...registerOptions,
    });
    const { name: fieldName, value, onChange } = field;
    return (_jsx(DatePicker, { ...appDatePickerProps, name: fieldName, selectedValue: value, error: fieldState.error?.message, onDateChange: onChange }));
};
